import {
  outer,
  inner,
  help,
  boxHelp,
  messages,
  message,
  prefix,
  suffix,
  fieldset,
  decorator,
  box,
  legend,
  boxOption,
  boxOptions,
  boxWrapper,
  boxLabel,
  options,
  checkboxes,
  $if,
  $extend, icon,
  defaultIcon
} from "@formkit/inputs"
import './checkbox.scss'
import {outerSection} from "~/libs/formkit/utils";

const checkboxOuter = outerSection({
  attrs: {
    'data-variant': "$variant || 'primary'",
  }
})

/**
 * Input definition for a checkbox(ess).
 * @public
 */
export const checkbox = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: checkboxOuter(
    $if(
      '$options == undefined',
      /**
       * Single checkbox structure.
       */
      boxWrapper(
        inner(
          prefix(),
          box(),
          decorator(
            $if('$value === true', icon('checkedIcon')),
            $if('$value !== true', icon('uncheckedIcon')),
          ),
          suffix()
        ),
        $if('$label', boxLabel('$label'))
      ),
      /**
       * Multi checkbox structure.
       */
      fieldset(
        legend('$label'),
        help('$help'),
        boxOptions(
          boxOption(
            boxWrapper(
              inner(
                prefix(),
                $extend(box(), {
                  bind: '$option.attrs',
                  attrs: {
                    id: '$option.attrs.id',
                    value: '$option.value',
                    checked: '$fns.isChecked($option.value)',
                  },
                }),
                  decorator(
                      $if('$fns.isChecked($option.value) === true', icon('checkedIcon')),
                      $if('$fns.isChecked($option.value) !== true', icon('uncheckedIcon')),
                  ),
                suffix()
              ),
              $if('$option.label', boxLabel('$option.label'))
            ),
            boxHelp('$option.help')
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    $if('$options.length === 0 && $help', help('$help')),
    messages(message('$message.value'))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'input',
  /**
   * An array of extra props to accept for this input.
   */
  props: ['options', 'onValue', 'offValue', 'variant'],
  /**
   * Additional features that should be added to your input
   */
  features: [
    defaultIcon('checkedIcon', 'checkboxChecked'),
    defaultIcon('uncheckedIcon', 'checkbox'),
    options,
    checkboxes,
  ],
}
